import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

function ClientInvoicesHeader({ title }) {
    const [pendingAmount, setPendingAmount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const fetchPendingAmount = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await axios.get('/api/client-requests/invoices/pending-total');
            setPendingAmount(response.data.pending_total || 0);
        } catch (error) {
            console.error('Error fetching pending amount:', error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPendingAmount();
    }, [fetchPendingAmount]);

    return (
        <>
            {/* Navigation Buttons */}
            <div className="client-finance-nav">
                <button
                    className={`toggle-button ${location.pathname.includes('/invoices') ? 'active' : ''}`}
                    onClick={() => navigate('/client/invoices')}
                >
                    View Invoices
                </button>
                <button
                    className={`toggle-button ${location.pathname.includes('/payments') ? 'active' : ''}`}
                    onClick={() => navigate('/client/payments')}
                >
                    View Payments
                </button>
            </div>

            {/* Header */}
            <div className="client-invoices-header">
                <h1 className="client-invoices-title">{title}</h1>
                <div className={`client-invoices-summary ${pendingAmount === 0 && !isLoading ? 'no-pending' : ''}`}>
                    {pendingAmount !== null && !isLoading ? (
                        pendingAmount === 0 ? (
                            <strong>No pending invoices</strong>
                        ) : (
                            <>
                                <strong>Total Pending Amount:</strong> AED {pendingAmount.toFixed(2)}
                            </>
                        )
                    ) : (
                        <strong>Loading...</strong>
                    )}
                </div>
            </div>
        </>
    );
}

export default ClientInvoicesHeader;
